import { __extends } from "tslib";
import { ShaderBase } from '@awayjs/renderer';
import { PassBase } from './PassBase';
/**
 * BasicMaterialPass forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var BasicMaterialPass = /** @class */ (function (_super) {
    __extends(BasicMaterialPass, _super);
    function BasicMaterialPass(renderMaterial, renderElements) {
        var _this = _super.call(this, renderMaterial, renderElements) || this;
        _this._diffuseR = 1;
        _this._diffuseG = 1;
        _this._diffuseB = 1;
        _this._diffuseA = 1;
        _this._shader = new ShaderBase(renderElements, renderMaterial, _this, _this._stage);
        _this.invalidate();
        return _this;
    }
    BasicMaterialPass.prototype._includeDependencies = function (shader) {
        _super.prototype._includeDependencies.call(this, shader);
        if (this._shaderTexture != null)
            shader.uvDependencies++;
    };
    BasicMaterialPass.prototype.invalidate = function () {
        _super.prototype.invalidate.call(this);
        var texture = this._renderMaterial.material.getTextureAt(0);
        this._shaderTexture = texture ? this._shader.abstractions.getAbstraction(texture) : null;
    };
    BasicMaterialPass.prototype.dispose = function () {
        if (this._shaderTexture) {
            this._shaderTexture.onClear();
            this._shaderTexture = null;
        }
        _super.prototype.dispose.call(this);
    };
    /**
     * @inheritDoc
     */
    BasicMaterialPass.prototype._getFragmentCode = function (regCache, sharedReg) {
        var code = '';
        var alphaReg;
        if (this.preserveAlpha) {
            alphaReg = regCache.getFreeFragmentSingleTemp();
            regCache.addFragmentTempUsages(alphaReg, 1);
            code += 'mov ' + alphaReg + ', ' + sharedReg.shadedTarget + '.w\n';
        }
        var targetReg = sharedReg.shadedTarget;
        if (this._shaderTexture != null) {
            code += this._shaderTexture._getFragmentCode(targetReg, regCache, sharedReg, sharedReg.uvVarying);
            if (this._shader.alphaThreshold > 0) {
                var cutOffReg = regCache.getFreeFragmentConstant();
                this._fragmentConstantsIndex = cutOffReg.index * 4;
                code += 'sub ' + targetReg + '.w, ' + targetReg + '.w, ' + cutOffReg + '.x\n' + 'kil ' + targetReg + '.w\n' + 'add ' + targetReg + '.w, ' + targetReg + '.w, ' + cutOffReg + '.x\n';
            }
        }
        else if (this._shader.colorBufferIndex != -1) {
            code += 'mov ' + targetReg + ', ' + sharedReg.colorVarying + '\n';
        }
        else {
            var diffuseInputReg = regCache.getFreeFragmentConstant();
            this._fragmentConstantsIndex = diffuseInputReg.index * 4;
            code += 'mov ' + targetReg + ', ' + diffuseInputReg + '\n';
        }
        if (this.preserveAlpha) {
            code += 'mul ' + sharedReg.shadedTarget + '.w, ' + sharedReg.shadedTarget + '.w, ' + alphaReg + '\n';
            regCache.removeFragmentTempUsage(alphaReg);
        }
        return code;
    };
    BasicMaterialPass.prototype._setRenderState = function (renderState) {
        _super.prototype._setRenderState.call(this, renderState);
        if (this._shaderTexture != null)
            this._shaderTexture._setRenderState(renderState);
    };
    /**
     * @inheritDoc
     */
    BasicMaterialPass.prototype._activate = function () {
        _super.prototype._activate.call(this);
        if (this._shaderTexture != null) {
            this._shaderTexture.activate();
            if (this._shader.alphaThreshold > 0)
                this._shader.fragmentConstantData[this._fragmentConstantsIndex] = this._shader.alphaThreshold;
        }
        else if (this._shader.colorBufferIndex == -1) {
            var index = this._fragmentConstantsIndex;
            var data = this._shader.fragmentConstantData;
            data[index] = this._diffuseR;
            data[index + 1] = this._diffuseG;
            data[index + 2] = this._diffuseB;
            data[index + 3] = this._diffuseA;
        }
    };
    return BasicMaterialPass;
}(PassBase));
export { BasicMaterialPass };
